import { jsx as _jsx } from "react/jsx-runtime";
import classnames from 'classnames';
import { ValidationStates } from '../../enums';
import styles from './HelperText.module.scss';
const HelperText = ({ children, className, id, validationState }) => {
    const isError = validationState === ValidationStates.Error;
    return (_jsx("div", { id: id, className: classnames(styles.helperText, className, {
            [styles.isError]: isError,
        }), children: children || '\u00A0' }));
};
export { HelperText };
